/**
 * @generated SignedSource<<88cc1b48d0342184fe93e611829b22db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AuthMenuQuery$variables = Record<PropertyKey, never>;
export type AuthMenuQuery$data = {
  readonly facebookLoginEnabled: boolean;
  readonly viewer: {
    readonly admin: boolean;
    readonly id: string;
    readonly image: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type AuthMenuQuery = {
  response: AuthMenuQuery$data;
  variables: AuthMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "image",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "admin",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "facebookLoginEnabled",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthMenuQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthMenuQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "64c2606c0f455fc59a9797c7fa963129",
    "id": null,
    "metadata": {},
    "name": "AuthMenuQuery",
    "operationKind": "query",
    "text": "query AuthMenuQuery {\n  viewer {\n    id\n    name\n    image\n    admin\n  }\n  facebookLoginEnabled\n}\n"
  }
};
})();

(node as any).hash = "d766076630dd6d57e40ae06e4ed22633";

export default node;
